import { useTranslation } from "@hireroo/i18n";
import * as z from "zod";
export const useFeedbackAnswer = () => {
  return z.enum(["YES", "NO", "NOT_SURE"]);
};

export type FeedbackAnswer = z.infer<ReturnType<typeof useFeedbackAnswer>>;

export const FeedbackCategoryReason = z.enum([
  "UNCLEAR_CRITERIA",
  "INSUFFICIENT_CRITERIA",
  "UNCLEAR_CHART",
  "SYSTEM_ERROR",
  "INSUFFICIENT_CHEAT_DETECTION",
  "OTHER",
]);
export type FeedbackCategoryReason = z.infer<typeof FeedbackCategoryReason>;

export const FeedbackUncertainCriteriaReason = z.enum(["CORRECTNESS", "READABILITY", "PERFORMANCE", "AVAILABILITY", "SCALABILITY"]);
export type FeedbackUncertainCriteriaReason = z.infer<typeof FeedbackUncertainCriteriaReason>;

export const useScoringPrecisionFeedbackFormSchema = () => {
  const { t } = useTranslation();
  const answer = useFeedbackAnswer();
  return z
    .object({
      answer: answer.optional(),
      entityTypes: z.array(z.enum(["CHALLENGE", "SYSTEM_DESIGN"])).optional(),
      categoryReasons: z.array(FeedbackCategoryReason).optional(),
      unclearCriteriaReasons: z.array(FeedbackUncertainCriteriaReason).optional(),
      comment: z.string().optional(),
    })
    .required({
      answer: true,
    })
    .superRefine((data, ctx) => {
      if (data.answer === "NO") {
        if (data.entityTypes?.length === 0) {
          ctx.addIssue({
            path: ["entityTypes"],
            code: z.ZodIssueCode.custom,
            message: t("最低一つは選択してください。"),
          });
        }
        if (data.categoryReasons?.length === 0) {
          ctx.addIssue({
            path: ["categoryReasons"],
            code: z.ZodIssueCode.custom,
            message: t("最低一つは選択してください。"),
          });
        }
        if (data.categoryReasons?.includes("UNCLEAR_CRITERIA") && data.unclearCriteriaReasons?.length === 0) {
          ctx.addIssue({
            path: ["unclearCriteriaReasons"],
            code: z.ZodIssueCode.custom,
            message: t("最低一つは選択してください。"),
          });
        }
      }
    });
};

export type ScoringPrecisionFeedbackFormSchema = z.infer<ReturnType<typeof useScoringPrecisionFeedbackFormSchema>>;
